// src/views/Estados/EliminarEstado.jsx
import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

function EliminarEstado({
  registro = {}, // { id, descripcion, tipo }
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setError("");
    setLoading(true);

    try {
      const id = registro.id;
      if (!id) throw new Error("Id del estado no encontrado.");

      const url = apiRoutes.estado.deleteUrl(id);

      // DELETE REAL
      await appFetchJson(url, {
        method: "DELETE",
      });

      // Avisar al padre que se eliminó
      // Cerrar el modal inmediatamente (UX fluida)
      onClose();

      // Avisar al padre que se eliminó (refresca la lista)
      onDeleted(registro);
    } catch (e) {
      console.error("Error al eliminar estado", e);

      // Intentar tomar el mensaje más útil posible
      const backendMessage =
        e?.message ||
        e?.response?.message ||
        e?.responseText ||
        "No fue posible eliminar el estado.";

      setError(backendMessage);
    }
  };

  return (
    <div className="w-full">
      {/* HEADER */}
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Estado</h2>
      </div>

      {/* BODY */}
      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm" style={{ color: "#1e72c0ff" }}>
          ¿Está seguro que desea eliminar este estado?
        </div>

        {/* PANEL DE DATOS */}
        <div className="mb-2 bg-gray-50 px-6 py-6">
          <div className="text-center space-y-3">
            <div>
              <span className="text-gray-500 mr-1">Descripción:</span>
              <span className="font-medium">{registro.descripcion || "—"}</span>
            </div>

            <div>
              <span className="text-gray-500 mr-1">Tipo:</span>
              <span className="font-medium">{registro.tipo || "—"}</span>
            </div>
          </div>
        </div>

        {/* MENSAJE DE ERROR */}
      </div>

      {/* FOOTER */}
      <div className="px-6 py-4 border-t flex items-center gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>

        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}

export default EliminarEstado;
